import { V1Hands } from "src/pages/reports/ffi/v1/types";

export const meta: Record<V1Hands, Opportunity> = {
    bibleStudy: {
        title: "How often do you attend Bible study, prayer meeting, youth group, or other religious activities?",
        prologue: "Administrators are deeply devoted to a local church body (Romans 12:4-5; Hebrews 10:25).",
    },
    devotions: {
        title: "How often does your family have devotions together?",
        prologue:
            "Administrators, teachers, alumni, and staff are diligent about engaging with the Bible, including reading and memorizing Scripture (Psalms 19:7-8; 119:15).",
    },
    pray: {
        title: "How often do you pray?",
        prologue:
            "Parents and teachers desire to grow in understanding and living according to the Bible (Hebrews 5:12-14, 6:1; John 15:5; Philippians 1:9).",
    },
    readTheBible: {
        title: "How often do you read the Bible?",
        prologue:
            "Students and alumni express optimism and purposefulness about their lives (Job 13:15; Jeremiah 29:11; Romans 5:5).",
    },
    religiousServices: {
        title: "How often do you attend religious services through your church / congregation?",
        prologue:
            "Students seek forgiveness from others and offer forgiveness when it is asked of them (Matthew 6:15; Ephesians 4:32; Colossians 3:13).",
    },
};
